import { v4 } from "uuid";
import { create } from "zustand";

interface SnackbarMessage {
	id: string;
	message: string;
}

interface SnackbarStore {
	messages: SnackbarMessage[];
	addMessage(message: string): void;
	removeMessage(id: string): void;
}

export const useSnackbarStore = create<SnackbarStore>((set, get) => ({
	messages: [],
	addMessage: (message: string) => {
		const id = v4();
		const msg: SnackbarMessage = { id, message };
		const messages = get().messages.slice();
		messages.push(msg);
		set({ messages });
	},
	removeMessage: (id: string) => {
		const messages = get().messages.slice();
		const index = messages.findIndex((m) => m.id === id);
		if (index === -1) return;
		messages.splice(index, 1);
		set({ messages });
	},
}));
